import _path from 'ramda/src/path';

const residential = [
    {
        name: 'resaas-tour',
        title: 'Discover the power of RESAAS (3 min)',
        description:
            'Join us on this virtual tour as we showcase the key features and benefits that make RESAAS the ultimate destination for real estate professionals.',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/3190d384-6a3f-41f0-a7dc-451629b60a83.png',
        cta: 'https://www.youtube.com/watch?v=Di5WdLDzb4g&list=PLpGkTkqrNhvX6bMZzQsDm-4QHGy3cDDk_&index=1',
        ctaText: 'Watch Now',
        successMessage: 'Your efforts are paying off!',
        newTab: true
    },
    {
        name: 'introduce-yourself',
        title: 'Network for Success',
        description:
            'Post about your background, skills, and journey. Your unique perspective is your competitive advantage.',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/af70c069-647f-48b8-a0e6-505eeceb5ede.png',
        cta: '/feed/global?createpost=1',
        ctaText: 'Start Sharing Now',
        successMessage: 'Your efforts are paying off!',
        newTab: false
    },
    {
        name: 'invite-someone',
        title: 'Maximize Your Network&apos;s Impact',
        description:
            'Invite others to join RESAAS and be a part of a dynamic network where collaboration and growth are at the forefront.',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/a77fedac-0f79-4be4-b6de-f64290a6c191.png',
        cta: '#invite',
        ctaText: 'Power Up Your Network',
        successMessage: 'Your efforts are paying off!',
        newTab: false
    },
    {
        name: 'maintain-listings',
        title: 'Stay Competitive',
        description:
            'Ensure your listings leave a positive impression.  Verify property details and update pricing when necessary to position yourself as a proactive and reliable agent.',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/79601dba-ce40-4011-a734-2f2e64b1b684.png',
        cta: '/mylistings',
        ctaText: 'Maintain My Listings',
        successMessage: 'Your efforts are paying off!',
        newTab: false
    },
    {
        name: 'default-feed',
        title: 'Start with what matters most',
        description:
            'Setting your default feed ensures that each time you return, you’re greeted with the content that matters most to you.',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/6c309840-b65e-4716-be69-3e3994f4c273.png',
        cta: '/mypreferences',
        ctaText: 'Set My Default Feed',
        successMessage: 'RESAAS, tailored just for you!',
        newTab: false
    },
    {
        name: 'marketing-tip',
        title: 'Share your marketing expertise',
        description:
            'Empower the RESAAS community with your tips on how to market listings. Your expertise can inspire others, elevate the industry and build your reputation.',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/c2d10427-b36d-462b-b5e5-4ebbaf173604.png',
        cta: '/feed/global?createpost=1',
        ctaText: 'Share Now',
        successMessage: 'Your community appreciates it!',
        newTab: false
    },
    {
        name: 'open-house',
        title: 'Amplify Your Open House',
        description:
            'Share the details of an upcoming open house and let the RESAAS community be part of your success. Create anticipation, and connect with potential attendees by posting in your global feed.',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/c165bdec-d62c-41e5-85d5-4b66abc2c16c.png',
        cta: '/feed/global?createpost=1',
        ctaText: 'Post Now',
        successMessage: 'Your efforts are paying off!',
        newTab: false
    },
    {
        name: 'coming-soon-listing',
        title: 'The Early Bird Gets the Sale',
        description:
        'Coming Soon listings create buzz for your property in advance, ensuring it stands out from the crowd. Don&apos;t wait, get ahead of the game!',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/d2b5b1ba-6819-4ec6-b0be-0332614e06cf.png',
        cta: '/mylistings',
        ctaText: 'Share Yours Now',
        successMessage: 'That&apos;s sure to grab some attention!',
        newTab: false
    }
];
const commercial = [
    {
        name: 'collaborate-investment',
        title: 'Collaborate on Investment Opportunities',
        description: 'Share and discuss investment deals with fellow brokers to identify partnership opportunities.',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/d75afe1e-25c0-48f1-b873-22ea64be874f.jpg',
        cta: '/feed/global?createpost=1',
        ctaText: 'Share Opportunities',
        successMessage: 'Your collaboration builds connections!',
        newTab: false
    },
    {
        name: 'coming-soon-listing',
        title: 'The Early Bird Gets the Sale',
        description:
            'Coming Soon listings create buzz for your property in advance, ensuring it stands out from the crowd. Don&apos;t wait, get ahead of the game!',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/59bfd102-0b5a-4ea9-afb2-f422400cbc3b.jpg',
        cta: '/mylistings',
        ctaText: 'Share Yours Now',
        successMessage: 'That&apos;s sure to grab some attention!',
        newTab: false
    },
    {
        name: 'introduce-yourself',
        title: 'Network for Success',
        description:
            'Post about your background, skills, and journey. Your unique perspective is your competitive advantage.',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/af70c069-647f-48b8-a0e6-505eeceb5ede.png',
        cta: '/feed/global?createpost=1',
        ctaText: 'Start Sharing Now',
        successMessage: 'Your efforts are paying off!',
        newTab: false
    },
    {
        name: 'exchange-market-data',
        title: 'Exchange Market Data with Peers',
        description: 'Share insights on market trends, cap rates, or property performance to enhance mutual knowledge.',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/da45b79c-6414-4e35-891c-d35738b878f7.jpg',
        cta: '/feed/global?createpost=1',
        ctaText: 'Post Market Insights',
        successMessage: 'Shared knowledge elevates us all!',
        newTab: false
    },
    {
        name: 'share-marketing-strategies',
        title: 'Share Marketing Strategies',
        description: 'Post your most effective strategies for marketing properties to inspire and educate fellow brokers.',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/b8a52b1f-8999-433b-897a-f76159c12450.jpg',
        cta: '/feed/global?createpost=1',
        ctaText: 'Share Strategies',
        successMessage: 'Your expertise is building community knowledge!',
        newTab: false
    },
    {
        name: 'host-virtual-tour',
        title: 'Host a Virtual Tour',
        description: 'Organize a virtual tour for a property and invite other brokers to share their insights or bring interested clients.',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/e6c86f7c-94ed-4ef4-ab0e-d1e20e40e95d.jpg',
        cta: '/feed/global?createpost=1',
        ctaText: 'Share an Upcoming Tour',
        successMessage: 'Your tour is connecting brokers!',
        newTab: false
    },
    {
        name: 'maintain-listings',
        title: 'Stay Competitive',
        description:
            'Ensure your listings leave a positive impression.  Verify property details and update pricing when necessary to position yourself as a proactive and reliable broker.',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/b22ee2c2-4b28-4eea-b979-c959b0202cf3.jpg',
        cta: '/mylistings',
        ctaText: 'Maintain My Listings',
        successMessage: 'Your efforts are paying off!',
        newTab: false
    },
    {
        name: 'default-feed',
        title: 'Start with what matters most',
        description:
            'Setting your default feed ensures that each time you return, you’re greeted with the content that matters most to you.',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/6c309840-b65e-4716-be69-3e3994f4c273.png',
        cta: '/mypreferences',
        ctaText: 'Set My Default Feed',
        successMessage: 'RESAAS, tailored just for you!',
        newTab: false
    },
    {
        name: 'connect-commercial-brokers',
        title: 'Find and Connect with Other Brokers',
        description: 'Browse the RESAAS broker page to discover and connect with top brokers in your area and beyond. Build your network for collaborations and referrals.',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/af70c069-647f-48b8-a0e6-505eeceb5ede.png',
        cta: '/agents',
        ctaText: 'Explore Brokers',
        successMessage: 'Your network just got stronger!',
        newTab: false
    },
    {
        name: 'showcase-deal-success',
        title: 'Showcase a Success Story',
        description: 'Share your recent success story. Outline how you tackled challenges and closed the transaction.',
        image: 'https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/96415afb-a1e2-4881-bdf3-7e300f562a5c.jpg',
        cta: '/feed/global?createpost=1',
        ctaText: 'Share Success Story',
        successMessage: 'Your success inspires the community!',
        newTab: false
    }
];

const UserTasks = _path(['Environment', 'Experience'], RESAAS) === 'commercial' ? commercial : residential;

export default UserTasks;
